var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoneageLogoFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 139,
    viewBox: "0 0 243 139",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.247 114.172L242.072 103.55L227.386 97.5838L223.133 93.079L209.151 78.4689L203.124 26.3288L198.534 24.8373L197.127 25.9026L195.261 51.1661L192.629 51.3791L189.57 49.3702L189.356 47.3918L186.725 45.2003L184.705 45.9612L184.032 45.322L180.575 10.0445L179.382 8.82699L138.047 3.16554L136.334 1.03489L131.836 0L116.783 6.23977L111.551 75.8512L83.6176 87.3263L83.1893 89.8831L79.579 92.3485H78.3246L64.6178 99.6536V101.023L52.2266 106.715L45.5567 116.394C45.5567 116.394 13.2173 129.452 0 138.158C37.9691 129.3 78.3246 123.608 134.376 122.756H163.135C189.692 123.152 214.995 124.674 238.339 127.078C237.391 125.069 236.993 122.969 236.993 120.96C236.993 118.829 237.421 116.547 238.278 114.172",
    stroke: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoneageLogoFill);
export default __webpack_public_path__ + "static/media/stoneage-logo-fill.8bed5f8d40ff1797faa782c41b3d0a09.svg";
export { ForwardRef as ReactComponent };